<template>
  <div id="FujiwaraCover">
    <p><span>♥</span>{{title}}<span>♥</span></p>
    <!-- <div class="arrow" :style="{ backgroundImage: `url(${publicPath}img/common/pink_arw.png)`}"></div> -->
  </div>
</template>

<script>
  // import _$ from 'jquery'
  // import _ from 'lodash'

  export default {
    name: 'FujiwaraCover',
    props: {
      qVal: String
    },
    data() {
      return {
        publicPath: process.env.BASE_URL,
        timer: null,
        title: null
      }
    },
    mounted(){
      let qNum = Number(this.qVal.substr(1, 1))
      if(qNum === 6){
        this.title = '最終問題'
      } else {
        this.title = qNum + "/5"
      }
      // this.blinkArrow()
      this.startTimer()
    },
    destroyed() {
      this.stopTimer()
    },
    watch: {
    },
    methods: {
      onClick: function(){
        this.$emit('panelTap');
      },
      // blinkArrow: function(){
      //   this.timer = setInterval(function(){
      //     _$('#FujiwaraCover .arrow').toggle()
      //   }.bind(this), 500)
      // },
      startTimer: function(){
        this.timer = setTimeout(function(){
          this.onClick();
          this.stopTimer()
        }.bind(this), 2000)
      },
      stopTimer: function(){
        // clearInterval(this.timer)
        clearTimeout(this.timer)
      }
    }
  }
</script>

<style lang="scss" scoped>
  #FujiwaraCover {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    p {
      font-size: toVW(60);
      letter-spacing: 0.2em;

      span {
        color: $COLOR_PINK01;
        margin: 0 0.2em;
      }
    }

    .arrow {
      background-repeat: no-repeat;
      background-size: contain;
      width: toVW(28);
      height: toVW(21);
      position: absolute;
      bottom: toVW(30);
      right: toVW(40);
      display: none;
    }

  }
</style>
